// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__e-8wS","subheader":"ReorderModal_subheader__2mSTz","listWrap":"ReorderModal_listWrap__31lAf"};